import { render } from "./Swipter.vue?vue&type=template&id=88f9fbd0&scoped=true"
import script from "./Swipter.vue?vue&type=script&lang=js"
export * from "./Swipter.vue?vue&type=script&lang=js"

import "./Swipter.vue?vue&type=style&index=0&id=88f9fbd0&scoped=true&lang=css"

import exportComponent from "D:\\sycode\\ijj-web\\iseso-mall-pc-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88f9fbd0"]])

export default __exports__